<template>
    <collapse-box-decorator trigger="click" vertical-position="top-out">
        <template #title>
            Aan pijplijn
        </template>
        <template #default="{ bindings }">
            <button-text v-bind="bindings" :disabled="availableLeads.length === 0">
                <svg-icon :icon="AddIcon" />
                <span><slot /></span>
            </button-text>
        </template>
        <template #content>
            <collapse-option-container>
                <collapse-option
                    v-for="lead in availableLeads"
                    :key="lead.id.value"
                    @click="redirectToCommentCreate(lead)"
                >
                    <lead-team-block :lead="lead" />
                </collapse-option>
            </collapse-option-container>
        </template>
    </collapse-box-decorator>
</template>

<script lang="ts" setup>
    import AddIcon from '@keyvue/one-material-icons/icons/add.svg?component';

    import { ButtonText, CollapseOption, CollapseOptionContainer, CollapseBoxDecorator, SvgIcon } from '@keyvue/one-ui';
    import { computed } from 'vue';
    import type { Lead } from '@keyvue/one-api-client';
    import LeadTeamBlock from '@components/Blocks/LeadTeamBlock.vue';
    import useParentRoute from '@composables/useParentRoute';
    import { useRouter } from 'vue-router';
    import useContactPageData from '@composables/useContactPageData';
    import useLeadSecurity from '@composables/security/useLeadSecurity';

    const createRouteLocation = useParentRoute();
    const router = useRouter();

    const { forLead: leadSecurityForLead } = useLeadSecurity();

    const availableLeads = computed(() => {
        const leads = leadCollection.data.value;

        return leads.filter((lead) => leadSecurityForLead(lead).canViewDetail.value);
    });

    const contactPageData = useContactPageData(String(router.currentRoute.value.params.contactId));

    const redirectToCommentCreate = (lead: Lead) => {
        router.push(createRouteLocation({
            name: 'LeadDetail',
            params: {
                leadId: lead.id.value,
            },
        }, 'contact'));
    };

    const leadCollection = await contactPageData.leadCollection();
</script>
